// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_txXwF {
  height : 496px;
  width: 496px;
  max-height: 100vh;
  position: relative;
}

.contentArea_jsUZZ {
  background: #f3f5f6;
}

.pad_j6wUo {
  padding: var(--size-padLarge, 10px);
}

.close_ZjxvI {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.locatorError_vAQB4 {
  margin: 0 auto;
}

.detailPair_cHlG9 {
  padding: 10px 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/components/LocatorAtSisterLocation.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  height : 496px;\n  width: 496px;\n  max-height: 100vh;\n  position: relative;\n}\n\n.contentArea {\n  background: #f3f5f6;\n}\n\n.pad {\n  padding: var(--size-padLarge, 10px);\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.locatorError {\n  margin: 0 auto;\n}\n\n.detailPair {\n  padding: 10px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_txXwF`,
	"contentArea": `contentArea_jsUZZ`,
	"pad": `pad_j6wUo`,
	"close": `close_ZjxvI`,
	"locatorError": `locatorError_vAQB4`,
	"detailPair": `detailPair_cHlG9`
};
export default ___CSS_LOADER_EXPORT___;
